import Vue from 'vue'
import Vuex from 'vuex'
import { setLocal, getLocal } from '@/utils/store'
import { setToken } from '@/utils/auth'
Vue.use(Vuex);
let store = new Vuex.Store({
  state: {
    token: getLocal({ name: 'token' }) || {},
    userInfo: getLocal({ name: 'userInfo' }) || {},
    welfarePhone: getLocal({ name: 'welfarePhone' }) || '', // 新人福利-电话
    wmsUserId: getLocal({ name: 'wmsUserId' }) || 0,//wms导购Id
  },
  mutations: {
    set_token (state, token) {
      setToken(token);
      state.token = token;
      setLocal({ name: 'token', content: state.token });
    },
    set_userInfo (state, userInfo) {
      state.userInfo = userInfo;
      setLocal({ name: 'userInfo', content: state.userInfo });
    },
    set_welfarePhone (state, phone) {
      state.welfarePhone = phone
      setLocal({ name: 'welfarePhone', content: state.welfarePhone })
    },
    set_wmsUserId (state, wmsUserId) {
      state.wmsUserId = wmsUserId;
      setLocal({ name: 'wmsUserId', content: state.wmsUserId });
    },
  },
  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
    welfarePhone: state => state.welfarePhone,
    wmsUserId: state => state.wmsUserId
  }
})

export default store